class ExchangeRateService {
  async fetchExchangeRate() {
    const API_URL = "https://crypto-rate-service.vercel.app";
    // const API_URL = "http://localhost:3000";

    try {
      const response = await fetch(`${API_URL}/api/rate`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const resData = await response.json();

        return {
          data: resData.data,
          source: resData.source,
        };
      }

      if (!response.ok) {
        const coingeckoData = await this.fetchFromCoinGecko();
        if (coingeckoData) {
          return {
            data: coingeckoData,
            source: "CoinGecko",
          };
        }

        const cryptocompareData = await this.fetchFromCryptoCompare();
        if (cryptocompareData) {
          return {
            data: cryptocompareData,
            source: "CryptoCompare",
          };
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async fetchFromCoinGecko() {
    try {
      const response = await fetch(
        "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,solana,binancecoin,tether,usd-coin&vs_currencies=brl,usd,eur,aed"
      );

      if (!response.ok) throw new Error("CoinGecko limit reached");

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("CoinGecko failed, trying Crypto Compare...");
      return null;
    }
  }

  async fetchFromCryptoCompare() {
    try {
      const response = await fetch(
        "https://min-api.cryptocompare.com/data/pricemulti?fsyms=BTC,ETH,SOL,BNB,USDT,USDC&tsyms=BRL,USD,EUR,AED"
      );
      if (!response.ok) throw new Error("CryptoCompare limit reached");
      const data = await response.json();
      return {
        bitcoin: {
          usd: data.BTC.USD,
          eur: data.BTC.EUR,
          brl: data.BTC.BRL,
          aed: data.BTC.AED,
        },
        ethereum: {
          usd: data.ETH.USD,
          eur: data.ETH.EUR,
          brl: data.ETH.BRL,
          aed: data.ETH.AED,
        },
        solana: {
          usd: data.SOL.USD,
          eur: data.SOL.EUR,
          brl: data.SOL.BRL,
          aed: data.SOL.AED,
        },
        binancecoin: {
          usd: data.BNB.USD,
          eur: data.BNB.EUR,
          brl: data.BNB.BRL,
          aed: data.BNB.AED,
        },
        tether: {
          usd: data.USDT.USD,
          eur: data.USDT.EUR,
          brl: data.USDT.BRL,
          aed: data.USDT.AED,
        },
        "usd-coin": {
          usd: data.USDC.USD,
          eur: data.USDC.EUR,
          brl: data.USDC.BRL,
          aed: data.USDC.AED,
        },
      };
    } catch (error) {
      console.error("CryptoCompare failed, trying Binance...");
      return null;
    }
  }

  async fetchFromCoinMarketCap() {
    try {
      const apiKey = "oi";
      const response = await fetch(
        `https://pro-api.coinmarketcap.com/v2/cryptocurrency/quotes/latest?symbol=BTC,ETH,SOL,BNB,USDT,USDC&convert=USD,EUR,BRL,AED`,
        {
          headers: {
            "X-CMC_PRO_API_KEY": apiKey,
          },
        }
      );
      if (!response.ok) throw new Error("CoinMarketCap limit reached");
      const data = await response.json();
      const quotes = data.data;

      return {
        bitcoin: {
          usd: quotes.BTC.quote.USD.price,
          eur: quotes.BTC.quote.EUR.price,
          brl: quotes.BTC.quote.BRL.price,
          aed: quotes.BTC.quote.AED.price,
        },
        ethereum: {
          usd: quotes.ETH.quote.USD.price,
          eur: quotes.ETH.quote.EUR.price,
          brl: quotes.ETH.quote.BRL.price,
          aed: quotes.ETH.quote.AED.price,
        },
        solana: {
          usd: quotes.SOL.quote.USD.price,
          eur: quotes.SOL.quote.EUR.price,
          brl: quotes.SOL.quote.BRL.price,
          aed: quotes.SOL.quote.AED.price,
        },
        binancecoin: {
          usd: quotes.BNB.quote.USD.price,
          eur: quotes.BNB.quote.EUR.price,
          brl: quotes.BNB.quote.BRL.price,
          aed: quotes.BNB.quote.AED.price,
        },
        tether: {
          usd: quotes.USDT.quote.USD.price,
          eur: quotes.USDT.quote.EUR.price,
          brl: quotes.USDT.quote.BRL.price,
          aed: quotes.USDT.quote.AED.price,
        },
        "usd-coin": {
          usd: quotes.USDC.quote.USD.price,
          eur: quotes.USDC.quote.EUR.price,
          brl: quotes.USDC.quote.BRL.price,
          aed: quotes.USDC.quote.AED.price,
        },
      };
    } catch (error) {
      console.error("CoinMarketCap failed, Trying CoinGecko");
      return null;
    }
  }

  async fetchFromKuCoin() {
    try {
      const response = await fetch(
        "https://api.kucoin.com/api/v1/market/allTickers"
      );
      if (!response.ok) throw new Error("KuCoin limit reached");
      const data = await response.json();

      console.log(data);

      const findPrice = (symbol) => {
        const coin = data.data.ticker.find((t) => t.symbol === symbol);
        return coin ? parseFloat(coin.last) : 0;
      };

      return {
        bitcoin: { usd: findPrice("BTC-USDT") },
        ethereum: { usd: findPrice("ETH-USDT") },
        solana: { usd: findPrice("SOL-USDT") },
        binancecoin: { usd: findPrice("BNB-USDT") },
      };
    } catch (error) {
      console.error("KuCoin failed");
      return null;
    }
  }

  async fetchFromKraken() {
    try {
      const response = await fetch(
        "https://api.kraken.com/0/public/Ticker?pair=XBTUSD,ETHEUR,SOLUSD,BNBBRL"
      );
      if (!response.ok) throw new Error("Kraken limit reached");
      const data = await response.json();

      return {
        bitcoin: { usd: data.result.XXBTZUSD.c[0] },
        ethereum: { eur: data.result.XETHZEUR.c[0] },
        solana: { usd: data.result.SOLUSD.c[0] },
        binancecoin: { brl: data.result.BNBBRL.c[0] },
      };
    } catch (error) {
      console.error("Kraken failed");
      return null;
    }
  }

  async fetchFromBinance() {
    try {
      const symbols = ["BTC", "ETH", "SOL", "BNB", "USDT", "USDC"];
      const currencies = ["BRL", "USD", "EUR", "AED"];
      const requests = symbols.flatMap((symbol) =>
        currencies.map((currency) =>
          fetch(
            `https://api.binance.com/api/v3/ticker/price?symbol=${symbol}${currency}`
          )
            .then((res) => res.json())
            .catch(() => null)
        )
      );

      const responses = await Promise.all(requests);
      const data = responses.reduce((acc, item) => {
        if (item && item.symbol && item.price) {
          const [crypto, fiat] = item.symbol.match(/[A-Z]+/g);
          if (!acc[crypto.toLowerCase()]) acc[crypto.toLowerCase()] = {};
          acc[crypto.toLowerCase()][fiat.toLowerCase()] = parseFloat(
            item.price
          );
        }
        return acc;
      }, {});

      return data;
    } catch {
      return null;
    }
  }
}

export const exchangeRateService = new ExchangeRateService();
